import React, {useEffect, useState} from 'react';
import {logPageLoadEvents} from '@ibibo/analytics';
import {
  userDataSelector,
  prevPageNameSelector,
  mpnfoSelector,
  existingUserSelector,
  userCountrySelector,
} from '../../store/selectors';
import {useSelector, useDispatch} from 'react-redux';

import OtpVerify from './containers/OtpVerify';
import VerifyEmailGcc from '../../stories/components/OnboardingNew/PopUp/VerifyEmailGcc/VerifyEmailGcc';
import {updatePreviousPageName} from '../../store/actions';
import OnboardingNew from '../../stories/components/OnboardingNew/OnboardingNew';

const VerifyPage = () => {
  const userInfo = useSelector(userDataSelector);
  const {email, mobile} = userInfo;
  const data = useSelector(prevPageNameSelector);
  const userCountry = useSelector(userCountrySelector);
  const mpnfoValue = useSelector(mpnfoSelector);
  const existingUser = useSelector(existingUserSelector);
  const {prevPageName} = data;
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const dispatch = useDispatch();

  useEffect(() => {
    const events = {
      // eVar34: email,
      eVar35: mobile,
      eVar23: prevPageName,
      eVar24: 'onboarding|mypartner',
      eVar37: userCountry
        ? 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng'
        : 'domain_sbu:india|domain_country:in|domain_currency:inr|domain_language:eng',
      eVar107: `mpnfo_${mpnfoValue}`,
    };
    logPageLoadEvents('onboarding:otpvalidation', events);
    dispatch(updatePreviousPageName('onboarding:otpvalidation'));
  }, [dispatch]);

  return (
    <OnboardingNew step={1}>
      {userCountry && !existingUser ? <VerifyEmailGcc /> : <OtpVerify />}
    </OnboardingNew>
  );
};

export default VerifyPage;
